export default __webpack_public_path__ + "static/media/guide_index.40ac823a.md";